import { useAtomValue } from "jotai";
import { useBenefitPaymentsData } from "pages/Dashboard/hooks/useBenefitPaymentsData";
import { useTranslation } from "react-i18next";
import { selectedBenefitCurrencyAtom } from "store/index";
import { useTheme } from "styled-components";

const initObj = {
  id: 0,
  size: 0,
  currency: "",
  color: "",
  name: "",
};

export function useCalculatedBenefitCosts() {
  const { t } = useTranslation();
  const theme = useTheme();

  const selectedCurrency = useAtomValue(selectedBenefitCurrencyAtom);
  const paymentData = useBenefitPaymentsData();

  const payments = paymentData.rawPayments;
  const paymentsPerCategory = paymentData.paymentsPerCategory;

  if (!payments || !paymentsPerCategory || !selectedCurrency || !payments[selectedCurrency]) {
    return {
      totalCost: initObj,
      totalCompanyCost: initObj,
      totalBenefitsCost: initObj,
      totalEmployeeWithDependentsCost: initObj,
      employeeCost: [initObj],
      dependentCost: [initObj],
      totalBenefitsCostPerCategory: [initObj],
    };
  }

  const totalBenefitsCost = {
    name: `${t("hbh.total.label")}`,
    size:
      payments[selectedCurrency]?.paidByCompany +
      payments[selectedCurrency]?.paidByCompanyForDependent +
      payments[selectedCurrency]?.paidByEmployee +
      payments[selectedCurrency]?.paidByDependent,
    color: theme.palette.purpleDark,
    currency: selectedCurrency,
  };

  const totalBenefitsCostPerCategorySelected = paymentsPerCategory[selectedCurrency] || {};

  const totalBenefitsCostPerCategory = Object.keys(totalBenefitsCostPerCategorySelected).map(
    (categoryTag) => {
      return {
        id: categoryTag,
        name: totalBenefitsCostPerCategorySelected[categoryTag]?.categoryName,
        size:
          totalBenefitsCostPerCategorySelected[categoryTag]?.paidByCompany +
          totalBenefitsCostPerCategorySelected[categoryTag]?.paidByCompanyForDependent +
          totalBenefitsCostPerCategorySelected[categoryTag]?.paidByEmployee +
          totalBenefitsCostPerCategorySelected[categoryTag]?.paidByDependent,
        color: theme.palette.purple,
        currency: selectedCurrency,
      };
    }
  );

  const totalEmployeeWithDependentsCost = {
    name: `${t("hbh.employeeWithDependents.label")}`,
    size: payments[selectedCurrency]?.paidByEmployee + payments[selectedCurrency]?.paidByDependent,
    color: theme.palette.purpleLight,
    currency: selectedCurrency,
  };

  const totalCompanyCost = {
    name: `${t("hbh.company.label")}`,
    size:
      payments[selectedCurrency]?.paidByCompany +
      payments[selectedCurrency]?.paidByCompanyForDependent,
    color: theme.palette.purple,
    currency: selectedCurrency,
  };

  const employeeCost = [
    {
      name: `${t("hbh.company.label")}`,
      size: payments[selectedCurrency]?.paidByCompany,
      color: theme.palette.purple,
      currency: selectedCurrency,
    },
    {
      name: `${t("hbh.employee.label")}`,

      size: payments[selectedCurrency]?.paidByEmployee,
      color: theme.palette.purpleLight,
      currency: selectedCurrency,
    },
    {
      name: `${t("hbh.total.label")}`,
      size: payments[selectedCurrency]?.paidByCompany + payments[selectedCurrency]?.paidByEmployee,
      color: theme.palette.purpleDark,
      currency: selectedCurrency,
    },
  ];

  const dependentCost = [
    {
      name: `${t("hbh.company.label")}`,

      size: payments[selectedCurrency]?.paidByCompanyForDependent,
      color: theme.palette.purple,
      currency: selectedCurrency,
    },
    {
      name: `${t("hbh.dependent.label")}`,

      size: payments[selectedCurrency]?.paidByDependent,
      color: theme.palette.purpleLight,
      currency: selectedCurrency,
    },
    {
      name: `${t("hbh.total.label")}`,

      size:
        payments[selectedCurrency]?.paidByCompanyForDependent +
        payments[selectedCurrency]?.paidByDependent,
      color: theme.palette.purpleDark,
      currency: selectedCurrency,
    },
  ];

  return {
    totalCompanyCost,
    totalBenefitsCost,
    totalEmployeeWithDependentsCost,
    employeeCost,
    dependentCost,
    totalBenefitsCostPerCategory,
  };
}
